import { vexStockImages } from '~/constants/environment';

const defaultImageURL = `${vexStockImages}/generic_vehicle_desktop_1920x1080.png`;

export function setDefaultImage(image: HTMLImageElement) {
  // To prevent infinite loop in case the defaultImageURL fails too
  if (image.src !== defaultImageURL) {
    image.src = defaultImageURL;
  }
}

/* Handler for default image */
export default function defaultImageHandler(event: any) {
  setDefaultImage(event.target);
}
